import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';

@Directive({
	selector: '[inputValidator]',
	providers: [{ provide: NG_VALIDATORS, useExisting: InputValidator, multi: true }]
})
export class InputValidator implements Validator {
	regexAtom = "[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]";
	regexIp = '\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\]';
	defaultRegexNumber = /^(\+|-)?[0-9]+((\.|,)?[0-9]+)?((e)?([0-9]+((\.|,)?[0-9]+))?)$/;
	defaultRegexPhone = /^(\(?\+?[0-9]*\)?)?[0-9_\- \(\)]?$/;
	defaultRegexPostalCode = /^[a-zA-Z][0-9][a-zA-Z](\ )?[0-9][a-zA-Z][0-9]$/;
	defaultRegexZipCode = /^[0-9]{5}$/;
	@Input('type') type: string;

	regexDomain() {
		return '(' + this.regexAtom + '+(\\.' + this.regexAtom + '+)*';
	}

	regexEmail() {
		return '^' + this.regexAtom + '+(\\.' + this.regexAtom + '+)*@' + this.regexDomain + '|' + this.regexIp + ')$';
	}

	validate(control: AbstractControl): { [key: string]: any } | null {
		switch (this.type) {
			case 'number':
				return regexValidator(new RegExp(this.defaultRegexNumber), 'number')(control);
			case 'email':
				return regexValidator(new RegExp(this.regexEmail()), 'email')(control);
			case 'tel':
				return regexValidator(new RegExp(this.defaultRegexPhone), 'tel')(control);
			case 'postalcode':
				return regexValidator(new RegExp(this.defaultRegexPostalCode), 'postalcode')(control);
			case 'zipcode':
				return regexValidator(new RegExp(this.defaultRegexZipCode), 'zipcode')(control);
			default:
				return null;
		}
	}
}

function regexValidator(regex: RegExp, type: string): ValidatorFn {
	return (control: AbstractControl): { [key: string]: any } | null => {
		const invalid = !regex.test(control.value);
		return invalid ? { type: { value: control.value } } : null;
	};
}
